import { dateReformatTo_mmm_dd_yyyy } from '@fuse/utils/dateOperations'
import CustomFilter from '@fuse/components/AgGridFilterGroupView/components/CustomFilter';
import { AgGridReact } from 'ag-grid-react';
import '../../../../../styles/ag-custom.css';
import React, { useMemo, useEffect, useState, useRef } from 'react'
import { Button, Breadcrumbs, Link, Card, CardContent, Box } from '@mui/material';
import { useRouter, useCurrentUser } from '@fuse/hooks';
import axios from '@fuse/utils/axios';
import NoResultView from '@fuse/components/NoResultView'
import FuseLoading from "@fuse/core/FuseLoading";

function Note({ setOpenAddNote, setEditNoteData, status, serviceRequestId }) {
  const gridRef = useRef();
  const router = useRouter()
  const currentUser = useCurrentUser()
  const requestId = router.params.id ?? serviceRequestId;
  const [noteList, setNoteList] = useState([])
  const [loadingState, setLoadingState] = useState(false)
  const header = [
		{
		  field: "notes",
		  headerName: "Notes",
		  minWidth: 350,
      headerComponent: CustomFilter		
		},
		{
		  field: "created_at",
		  headerName: "Created Date",
      headerComponent: CustomFilter		
		},
		{
		  field: "agent_name",
		  headerName: "Agent Name",
      headerComponent: CustomFilter	
		},
    {
		  field: "updated_at",
		  headerName: "Updated Date",
      headerComponent: CustomFilter	
		},
		{
		  field: "actions",
		  headerName: "Actions",
							suppressMenu: true,          
							suppressHeaderMenuButton: true,
							sortable: false,
		  minWidth: 100,
		  maxWidth: 100,
      headerComponent: CustomFilter		
		}
	]
  const [tableHeaders, setTableHeaders] = useState(header)
  // useEffect(()=>{
  //   setNoteList(notes.map(item=>({...item,created_at:dateReformatTo_mmm_dd_yyyy(item.created_at), 
  //     updated_at: dateReformatTo_mmm_dd_yyyy(item.updated_at)})))
  // },[notes])

  const fetchNotes = () => {
    setLoadingState(true)
    axios.get(`/service/list-notes/${requestId}`).then((res)=>{
      setNoteList(res.data.data.response.map(item=>({...item,created_at:dateReformatTo_mmm_dd_yyyy(item.created_at), 
        updated_at: dateReformatTo_mmm_dd_yyyy(item.updated_at)})))  
      setLoadingState(false)
    }).catch((err)=>{
      setLoadingState(false)
      console.log(err)
    })
  }

  const columnDefs = useMemo(() => {
    const cols = tableHeaders.map((head) => {
      const baseCol = {
        field: head.field,
        headerName: head.headerName,
        minWidth: head.minWidth,
        maxWidth: head.maxWidth,
        flex: 1,
        sortable: false,
        filter: 'agTextColumnFilter',
        wrapText: true,
        autoHeight: true,
        headerComponent: (props) => CustomFilter(props, head, gridRef),
      };

      if (head.field === 'notes') {
        return {
          ...baseCol,
          cellRenderer: (params) => (
            <span style={{ wordBreak: 'break-word' }}>{params.value}</span>
          ),
        };
      }

      if (head.field === 'actions') {
        return {
          ...baseCol,
          cellRenderer: (params) => {
            const { data } = params;
            if (!data || data.user_companies_users_id !== currentUser.data.id) return '';
            return (
              <Button
                disabled={status === 'Closed'}
                onClick={() => {
                  setOpenAddNote(true);
                  setEditNoteData(params);
                }}
                className="transparent_icon_btn text-center"
              >
                <i
                  style={{
                    fontSize: '20px',
                    fontWeight: '500',
                    color: '#1D2939',
                  }}
                  className="ti ti-pencil"
                />
              </Button>
            );
          },
        };
      }

      return baseCol;
    });

    return cols;
  }, [tableHeaders, status, currentUser, setOpenAddNote, setEditNoteData]);

  useEffect(() => {
    fetchNotes()
  }, [])

  useEffect(() => {
    if (status == 'Closed') setTableHeaders(tableHeaders.slice(0, -1))
  }, [status])

  if (loadingState) {
    return (
      <FuseLoading />
    )
  }

  if(!noteList.length){
    return (
      <NoResultView moduleName="Note" />
    )
  }

  return (
    <>
    <div 
          className="ag-theme-alpine" 
          style={{
          width: "100%",
          height: 400,
          fontSize:'12px'
          }}
      >
          <AgGridReact
              ref={gridRef}
              rowData={noteList}
              columnDefs={columnDefs}
              animateRows
              // onGridReady = { onGridReady }
              paginationPageSize={10}
          paginationPageSizeSelector={[10, 20, 50, 100]}
              pagination
              rowHeight={30}
              headerHeight={44}
              defaultColDef={{
                resizable: true
              }}
        />
      </div>
    </>
  )
}

export default Note